import styled from 'styled-components';
interface ImageWrapperProps {
  position?: string;
  width: string | Number | undefined;
  height: string | Number | undefined;
  borderSize?: number;
  rounded?: boolean;
  objectFit?: 'cover' | 'contain';
}

export const ImageWrapper = styled.img<ImageWrapperProps>`
  ${({ width, height, borderSize = 0 }) => `
  width: ${width}px;
  height: ${height}px;
  border: ${borderSize}px solid #FFFF;
  `}

  position: ${({ position }) => (position ? position : 'static')};
  border-radius: ${({ rounded }) => (rounded ? '50%' : '10px')};
  object-fit: ${({ objectFit = 'cover' }) => objectFit};
  background: transparent;
`;
